import React, { useEffect } from "react";
import "./premiumTemplate.scss";

import Image from "../../../../component/image/Image";
import SingleSelect from "../../../../component/singleSelect/SingleSelect";
import Pagination from "../../../../component/pagination/Pagination";
import JobMapList from "../JobMapList";
import MicroJobNotFound from "../jobapplication/MicroJobNotFound";
import OptionThreeJobViewPage from "../OptionThree/OptionThreeJobViewPage";
import NoJobMatch from "../OptionThree/NoJobMatch";

import locationIcon from "../../../../assets/images/locationicon.svg";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import useClientConfig from "../../../../config/careers/clientConfig";
import { getQuestionList } from "../../../../redux/slices/careersSlices.reducer";
import PremimumNoJobMatch from "./PremimumNoJobMatch";

const PremiumJobListing = (props: any) => {

  const {
    location,
    clientId,
    checkListControl,
    jobsList,
    setListView,
    listView,
    setTableControl,
    tableControl,
    sortList,
    pageSizeChange,
    displayPage,
    filterView,
    moveToJobViewPage,
    publishingDate,
    pageChange,
    filterListData,
    searchControlSubmit,
    navigateToJob,
    isMicroSite,
    isMapViewEnabled,
    getListOfJob,
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const clientConfig = useSelector(
    (state: any) => state.careers.cliendConfig
  );

  const langLabels =
    clientConfig?.data?.data?.clientSettings?.languageSettings;

  const language =
    clientConfig?.data?.data?.clientSettings?.language;

  const jobListingLangLabels =
    langLabels?.jobListing?.[0];

  const { clientSiteSettings } = useClientConfig();

  const learnMoreBtn =
    clientSiteSettings?.learnMoreBtnInList || false;

  const applyNowBtn =
    clientSiteSettings?.applyNowBtnInList || false;

  useEffect(() => {
    dispatch<any>(getQuestionList());
  }, [dispatch]);

  const selectedSortList = {
    value: tableControl?.sort?.value,
    label: t(tableControl?.sort?.label),
  };

  const selectedPageSize = {
    value: tableControl?.pageSize?.value,
    label:
      tableControl?.pageSize?.value + " " + t("per page"),
  };

  const langSortList = sortList.map((item: any) => ({
    value: item.value,
    label: t(item.label),
  }));

  const langPageSize = displayPage.map((item: any) => ({
    value: item.value,
    label: item.value + " " + t("per page"),
  }));

  const navigateToApplyJob = (jobId: string) => {
    navigate(`/view/${jobId}/apply-job/from/direct`);
  };

  const navigateToJobAlerts = () => {
    navigate("/job-alerts");
  };

  // JOB VIEW PAGE
  if (location.pathname !== "/") {

    return (

      <OptionThreeJobViewPage
        jobDataView={filterView()}
        filterListData={filterListData}
        tableControl={tableControl}
        setTableControl={setTableControl}
        searchControlSubmit={searchControlSubmit}
        clientId={clientId}
        navigateToJob={navigateToJob}
        getListOfJob={getListOfJob}
      />

    );

  }

  return (

    <div className="pt-container">

      {/* SEARCH */}
      <div className="pt-search-section">
        {filterView()}
      </div>


      {/* TOOLBAR */}
      <div className="pt-toolbar">

        <div>
          {checkListControl
            ? t("Search Results")
            : jobListingLangLabels?.showingAll}

          <span className="pt-count">
            {" "}
            {jobsList?.data?.data?.jobs?.totalRecord || 0}
          </span>
        </div>

        <div className="pt-toolbar-right">

          <div className="pt-select">
            <label>{t("Sort")}</label>
            <SingleSelect
              value={selectedSortList}
              options={langSortList}
              onChange={(e: any) =>
                setTableControl((prev: any) => ({
                  ...prev,
                  sort: e,
                }))
              }
              isSearchable={false}
            />
          </div>

          <div className="pt-select">
            <label>{t("Display")}</label>
            <SingleSelect
              value={selectedPageSize}
              options={langPageSize}
              onChange={pageSizeChange}
              isSearchable={false}
            />
          </div>

        </div>

      </div>

      {/* JOB LIST GRID */}
      {tableControl.data.length > 0 ? (

        listView === "list" ? (

          <div className="pt-grid">

            {tableControl.data.map((job: any) => (

              <div key={job.id} className="pt-card">

                <div className="pt-card-header">

                  <h2
                    className="pt-card-title"
                    onClick={() => moveToJobViewPage(job)}
                  >
                    {job.title}
                  </h2>

                  <img
                    src={
                      job.logo
                        ? job.logo
                        : "https://stag-compliance-careers.s3.ap-southeast-2.amazonaws.com/career-doc-settings/uploads/no_image.png"
                    }
                    className="pt-card-logo"
                    alt="logo"
                  />

                </div>

                <div
                  className="pt-card-desc"
                  dangerouslySetInnerHTML={{
                    __html: job.description,
                  }}
                />

                <div className="pt-card-footer">

                  <div className="pt-card-meta">

                    {/* LOCATION */}
                    {job.location?.location && (
                      <div className="pt-card-location">
                        <Image src={locationIcon} />
                        <span>{job.location.location}</span>
                      </div>
                    )}

                    {/* POSTED DATE */}
                    {job.postedAt && (
                      <div className="pt-card-posted">
                        <span className="pt-posted-label">
                          {t("Posted")}:
                        </span>
                        <span className="pt-posted-date">
                          {publishingDate(job.postedAt, language)}
                        </span>
                      </div>
                    )}

                  </div>

                  <div className="pt-card-actions">

                    {learnMoreBtn && (
                      <button
                        className="pt-btn-outline"
                        onClick={() =>
                          moveToJobViewPage(job)
                        }
                      >
                        Learn more
                      </button>
                    )}

                    {applyNowBtn && (
                      <button
                        className="pt-btn-solid"
                        onClick={() =>
                          navigateToApplyJob(job.id)
                        }
                      >
                        Apply now
                      </button>
                    )}

                  </div>

                </div>

              </div>

            ))}

          </div>

        ) : (

          <JobMapList jobList={tableControl.data} />

        )

      ) : (

        isMicroSite === 1
          ? <MicroJobNotFound />
          : <div>{tableControl.massage}</div>

      )}

      {/* PAGINATION */}
      <Pagination
        currentPage={tableControl.currentPage}
        totalCount={tableControl.totalCount}
        pageSize={tableControl.pageSize?.value}
        onPageChange={pageChange}
      />

      {/* NO JOB MATCH BELOW */}
      <div className="pt-bottom-match">

        <PremimumNoJobMatch
          navigateToJob={navigateToJob}
          navigateToJobAlerts={navigateToJobAlerts}
          langLabels={langLabels}
          {...props}
        />

      </div>

    </div>

  );

};

export default PremiumJobListing;